export default __webpack_public_path__ + "static/media/Java.296ad27c.png";